<template>
  <pp-modal v-model="showModal" :mask-closable="false" width="488">
    <p slot="header" class="modalHead">
      <span>{{ modalheader }}</span>
    </p>
    <div class="modalContent">
      <p>{{ modalcontent }}</p>
    </div>
    <div slot="footer" class="textright">
      <pp-button class="pp-btn pp-btn-ghost pp-btn-spec" @click="leftBtnFun">取消</pp-button>
      <pp-button class="pp-btn pp-btn-primary pp-btn-spec" @click="toService">{{ modalbtn }}</pp-button>
    </div>
  </pp-modal>
</template>

<script>
export default {
  name: 'SuccessModal',
  props: {
    // tourl: "",
    // eslint-disable-next-line vue/require-prop-type-constructor
    modalcontent: Number | Object | String | Boolean,
    // eslint-disable-next-line vue/require-prop-type-constructor
    modalheader: Number | Object | String | Boolean,
    // eslint-disable-next-line vue/require-prop-type-constructor
    modalbtn: Number | Object | String | Boolean

  },
  data() {
    return {
      showModal: false
    }
  },
  mounted() {},
  methods: {
    // 联系客服
    toService() {
      const win = window.open()
      this.$openHref('http://q.url.cn/cdiXhC?_type=wpa&qidian=true', win)
    },
    leftBtnFun() {
      this.showModal = false
    },
    show() {
      this.showModal = true
    }
  }
}
</script>

<style lang="scss" scoped>
    .modalHead {
        color: #000;
        font-size: 20px;
        text-align: left
    }

    .modalContent {
        text-align: left;
        font-size: 14px;
    }
</style>
